<template>
    <div class="administrative-tasks">
        <div class="title">
            <app-title>Tareas administrativas</app-title>
        </div>
        <div class="content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style></style>
